import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from '../../config/apiConfig.js';

interface PaymentHistoryItem {
  id: string;
  date: string;
  type: string;
  amount: string;
  method: string;
  status: string;
}

export const usePaymentHistory = () => {
  const [paymentHistory, setPaymentHistory] = useState<PaymentHistoryItem[]>([]);
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);

  const fetchTransactionHistory = async () => {
    setPaymentHistoryLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `${apiConfig.apiBaseURL}/transaction-history`,
        {
          headers: {
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
          },
        }
      );

      // Process the API response to match our PaymentHistory component interface
      if (
        response.data &&
        response.data.data &&
        response.data.data.transactions
      ) {
        const transactions = response.data.data.transactions.map(
          (transaction: any): PaymentHistoryItem => ({
            id: transaction.transactionId || transaction.id || transaction._id,
            date: transaction.date
              ? new Date(transaction.date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
              : "N/A",
            type:
              transaction.type === "gift"
                ? "Gift Purchase"
                : transaction.type === "subscription"
                ? "Subscription"
                : transaction.type || "Payment",
            amount: transaction.amountPaid
              ? `$${transaction.amountPaid.toFixed(2)}`
              : "N/A",
            method:
              transaction.paymentMethod ||
              (transaction.cardDetails
                ? `**** **** **** ${transaction.cardDetails.last4}`
                : "Card"),
            status: transaction.status || "Success",
          })
        );

        setPaymentHistory(transactions);
      } else {
        setPaymentHistory([]);
      }
    } catch (error) {
      console.error("Error fetching transaction history:", error);
      if (axios.isAxiosError(error)) {
        console.error("Request details:", {
          url: error.config?.url,
          method: error.config?.method,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
        });
      }
      toast.error("Failed to load payment history");
      setPaymentHistory([]);
    } finally {
      setPaymentHistoryLoading(false);
    }
  };

  return {
    paymentHistory,
    paymentHistoryLoading,
    fetchTransactionHistory
  };
};